export default "__VITE_ASSET__Cri$DY51__"